import {IDS} from '../requirements-assessment-action-id.constants';
// import { IDS as MASTER_DOC_LIST_IDS } from '../../master-doc-list/master-doc-list-action-id.constants';
import {TYPES} from "../requirements-assessment-action-type.constants";
import * as Actions from './evidence-group-details.actions';
import * as EvidenceActions from '../requirements-assessment.actions';
import * as AccAction from '../../accreditation.actions';
import {GRID_FILTER, GRID_RELOAD} from "../../../../common/grid/grid.constants";
import get from 'lodash/get';
import {TAB_SHOW} from "../../../../common/tabs/tabs.constants";

class EvidenceGroupDetailsController {
    constructor($ngRedux,
                $state,
                $stateParams,
                $filter,
                $timeout,
                $transitions,
                Notifier,
                DocumentManager,
                EmployeeService,
                AuthService,
                FileActions,
                $scope) {
        this.$ngRedux = $ngRedux;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$filter = $filter;
        this.$timeout = $timeout;
        this.$transitions = $transitions;
        this.Notifier = Notifier;
        this.DocumentManager = DocumentManager;
        this.EmployeeService = EmployeeService;
        this.AuthService = AuthService;
        this.FileActions = FileActions;
        this.identifier = IDS.rcoRequirementsAssessment;
        this.$scope = $scope;
    }

    $onInit() {
        this.schemeCode = this.$stateParams.itemCode;
        const user = this.AuthService.getUser();
        this.userUuid = user.uuid;
        this.isAdmin = user.type === 'Administrator';
        const auditorStateIconColors = {
            'pen': 'gray',
            'app': 'green',
            'nap': 'red',
        };

        this.unsubscribe = this.$ngRedux.connect(state => {
            const accDashboardLocationYear = state.accreditation.accDashboardLocationYear;
            const subModule = state.accreditation[this.identifier];
            const details = subModule.evidenceDetails;
            const gridItems = subModule[IDS.rcoEvidenceGroupDocumentsGrid].items;
            // const approvedCheckboxes = subModule[IDS.rcoEvidenceGroupDocumentsGrid].approved.itemsSelect || [];
            // const returnedCheckboxes = subModule[IDS.rcoEvidenceGroupDocumentsGrid].returned.itemsSelect || [];
            const auditor = subModule.auditors.find(item => item.assignee_uuid === this.userUuid);
            const userIsAuditor = !!auditor;
            const requirement = state.accreditation.selectedRequirement;

            return {
                details,
                documentDetails: subModule.documentDetails,
                evidenceStatusColor: details.status_code === 'app' ? 'green'
                                   : details.status_code === 'nap' ? 'red' : 'black',
                requirementName: requirement?.name,
                requirementDescription: get(requirement,'description','')?.replace(/\n/g,'<br>'),
                fiscalYear:         accDashboardLocationYear.year,
                locationName:       subModule.selectedSiteLocation?.locationName,
                siteLocationUuid:   subModule.selectedSiteLocation?.uuid,
                headOfficeUuid:     subModule.selectedHeadOffice?.uuid,

                requirement,
                auditors:           subModule.auditors.map(item => ({
                                        ...item,
                                        label: item.assignee,
                                        status: item.evidence_assessment_status === 'app' ? 'Approved'
                                              : item.evidence_assessment_status === 'nap' ? 'Not Approved'
                                              : 'Pending',
                                        icon: `user-${auditorStateIconColors[item.evidence_assessment_status] || 'gray'}.svg`
                                    })),
                selectedAuditTask:  this.isAdmin ? subModule.selectedAuditTask : subModule.auditors?.find(item => item.assignee_uuid === this.userUuid)?.uta_id,
                isAuditScheduled:   !!subModule.auditors.length,
                // areAllDocumentsUploaded: !!gridItems && gridItems.filter(item => !item.uri).length === 0,
                noDocumentsUploaded: !gridItems?.length,
                isDocumentGeneratable: !!details.generator_type,
                disableSubmissionOfApproval: auditor?.evidence_assessment_status === 'app' || (!this.isAdmin && !userIsAuditor),
                areAllDocsMarkedApproved: false, //!!gridItems && gridItems.length > 0 && gridItems.every(item => approvedCheckboxes.includes(item.id)),
                areAnyDocsMarkedReturned: false, //!!gridItems && returnedCheckboxes.length > 0,
                gridItemsCount: !!gridItems && gridItems.length,
                auditorsSelectOptions: subModule.auditorsSelectOptions,
                selectedEvidenceOwner: subModule.selectedEvidenceOwner,
                firstDocType: state.accreditation.common.documentTypes[0].value,
            }
        }, {
            ...AccAction,
            ...EvidenceActions,
            ...this.FileActions,
            ...Actions,
        })(this);

        this.onEnterUnsubscribe = this.$transitions.onEnter({
            to: IDS.app_accreditation_scheme_requirements_assessment_evidence_groups_details
        }, () => {
            this.selectedDocumentUuid = null;
            this.selectedDocumentName = null;

            if(this.siteLocationUuid) {
                this.resetSelectedAuditTask();
                this.fetchRequirementAuditorStatuses(this.requirement?.id, this.siteLocationUuid, this.fiscalYear, this.userUuid, this.details.ard_id)
            }
            this.$ngRedux.dispatch({
                type: GRID_FILTER,
                id: this.identifier,
                path: IDS.rcoEvidenceGroupDocumentsGrid,
                filter: {
                    identifier:     this.identifier,
                    scheme_code:    this.schemeCode,
                    evidence_group: this.details.ard_id,
                    requirement:    this.requirement?.id,
                    fiscal_year:    this.fiscalYear,
                    slo_uuid:       this.siteLocationUuid,
                }
            });
        });
    }

    onSelectDocument ({item}) {
        // Temporary disabled jumping from evidence group document to master doc list doc details
        // this.$state.go(
        //     MASTER_DOC_LIST_IDS.app_accreditation_scheme_master_doc_list_details,
        //     {
        //         itemCode: this.schemeCode,
        //         doc: item.id,
        //         year: this.fiscalYear,
        //         slo: this.siteLocationUuid,
        //         hof: this.headOfficeUuid,
        //     },
        // );
    }

    async onEvidenceOwnerAutocompleteKeywordQuery (keyword) {
        return await this.fetchEmployeesAndManagers(
            keyword,
            this.siteLocationUuid,
            `${this.identifier}.${IDS.rcoEvidenceOwnerCandidates}`
        );
    }

    onBtnAddEvidenceOwner () {
        if(!this.selectedEvidenceOwner) {
            this.Notifier.error(this.$filter('translate')('COMMON.CLIENT_RESPONSE.NO_ITEMS_SELECTED'));
            return;
        }
        this.addEvidenceOwner({
            evidence_group: this.details.ard_id,
            audit_task:     this.selectedAuditTask,
            owner_uuid:     this.selectedEvidenceOwner.subject_uuid,
            requirement:    this.requirement?.id,
        }).then(() => {
            this.Notifier.success(this.$filter('translate')('COMMON.SERVER_RESPONSE.ITEM_UPDATED'));
            this.$ngRedux.dispatch({
                type: TYPES.RESET_SELECTED_EVIDENCE_OWNER,
                id: IDS.rcoRequirementsAssessment,
            });
            // Refresh evidence group details to show the newly added owner
            this.reloadDetailsAndStatuses();
        });
    }

    onBtnUpdateEvidenceOwner () {
        if(!this.selectedEvidenceOwner) {
            return this.Notifier.error(this.$filter('translate')('COMMON.CLIENT_RESPONSE.NO_ITEMS_SELECTED'));
        }
        if(this.selectedEvidenceOwner.subject_uuid === this.details.review_task_assignee_uuid) {
            return this.Notifier.info(this.$filter('translate')('COMMON.CLIENT_RESPONSE.ITEM_PRESENT_ALREADY'));
        }
        this.addEvidenceOwner({
            evidence_group: this.details.ard_id,
            audit_task:     this.selectedAuditTask,
            owner_uuid:     this.selectedEvidenceOwner.subject_uuid,
            requirement:    this.requirement?.id,
        }).then(() => {
            this.Notifier.success(this.$filter('translate')('COMMON.SERVER_RESPONSE.ITEM_UPDATED'));
            this.$ngRedux.dispatch({
                type: TYPES.RESET_SELECTED_EVIDENCE_OWNER,
                id: IDS.rcoRequirementsAssessment,
            });
            // Refresh evidence group details to show the newly added owner
            this.reloadDetailsAndStatuses();
        });
    }

    // getFiscalYear () {
    //     const fiscalYearStart = moment().month(this.fiscalYearStart).day(0);
    //     return moment().isAfter(fiscalYearStart) ? moment().year() : moment().year() - 1;
    // }

    onDownloadButton() {
        this.download(`storage${this.details.doc_url}`);
    }
    onGenerateDocumentButton() {
        this.generateDocument({
            ard_id:         this.details.ard_id,
            slo_uuid:       this.siteLocationUuid,
            year:           this.fiscalYear,
            doc_version:    this.details.doc_version || 1,
        }).then(({params}) => {
            this.$ngRedux.dispatch({
                type: TYPES.SAVE_UPLOADED_DOCUMENT,
                id: IDS.rcoRequirementsAssessment,
                path: IDS.rcoRequirementsAssessment,
                filePath: params.file_path,
                doc_id: params.id,
            });
            this.$ngRedux.dispatch({
                type: GRID_RELOAD,
                id: IDS.rcoRequirementsAssessment,
                path: IDS.rcoEvidenceGroupsProgressGrid
            });
            this.$ngRedux.dispatch({
                type: GRID_RELOAD,
                id: IDS.rcoRequirementsAssessment,
                path: IDS.rcoEvidenceGroupHistoryGrid
            });
            this.reloadDetailsAndStatuses();
        });}

    onDownloadSampleButton() {
        this.download(`storage${this.details.sample_doc_uri}`);
    }

    onUploadSave(event,ctrl) {
        // const details = this.$ngRedux.getState().accreditation.rcoRequirementsAssessment.evidenceDetails;
        const {doc_new_version, name, doc_num, doc_type} = this.documentDetails;
        this.addDocumentVersion({
            ard_id:     this.details.ard_id,
            vdo_uuid:   this.selectedDocumentUuid,
            slo_uuid:   this.siteLocationUuid,
            file_path:  event[0].filePath,
            audit_uta_id:   this.selectedAuditTask,
            doc_version:this.selectedDocumentUuid? undefined : doc_new_version || 1, // if new version is not specified, default to 1
            name:       this.selectedDocumentUuid? undefined : name,
            doc_num:    this.selectedDocumentUuid? undefined : doc_num,
            doc_type:   doc_type,
        }).then(({params}) => {
            this.onCancelUpdateButton();
            this.$ngRedux.dispatch({
                type: TYPES.SAVE_UPLOADED_DOCUMENT,
                id: IDS.rcoRequirementsAssessment,
                path: IDS.rcoRequirementsAssessment,
                filePath: event[0].filePath,
                doc_id: params.id,
            });
            this.$ngRedux.dispatch({
                type: GRID_RELOAD,
                id: IDS.rcoRequirementsAssessment,
                path: IDS.rcoEvidenceGroupDocumentsGrid
            });
            this.$ngRedux.dispatch({
                type: GRID_RELOAD,
                id: IDS.rcoRequirementsAssessment,
                path: IDS.rcoEvidenceGroupHistoryGrid
            });
            this.reloadDetailsAndStatuses();
        })
    }
    onUpdateGridButton({item}) {
        this.selectedDocumentUuid = item.id;
        this.selectedDocumentName = item.name;
    }

    onApproveGridButton({item}) {
        this.setDocumentAssessment({
            vdo_uuid: item.id,
            status_code: 'app',
            evidence_group: this.details.ard_id,
            requirement:    this.requirement?.id,
            slo_uuid:       this.siteLocationUuid,
            audit_task:     this.selectedAuditTask,
        }).then(() => {
            this.$ngRedux.dispatch({
                type: GRID_RELOAD,
                id: IDS.rcoRequirementsAssessment,
                path: IDS.rcoEvidenceGroupDocumentsGrid
            });
            this.$ngRedux.dispatch({
                type: GRID_RELOAD,
                id: IDS.rcoRequirementsAssessment,
                path: IDS.rcoEvidenceGroupsProgressGrid
            });
            this.$ngRedux.dispatch({
                type: GRID_RELOAD,
                id: IDS.rcoRequirementsAssessment,
                path: IDS.rcoEvidenceGroupHistoryGrid
            });
            this.reloadDetailsAndStatuses();
        });
    }

    onRejectGridButton({item}) {
        this.$ngRedux.dispatch({
            type: TYPES.SET_DOCUMENT_FOR_REVISION_REQUEST,
            id: IDS.rcoRequirementsAssessment,
            item,
        });
        this.$ngRedux.dispatch({
            type: TAB_SHOW,
            id: IDS.app_accreditation_scheme_requirements_assessment_evidence_groups,
            state: IDS.app_accreditation_scheme_requirements_assessment_evidence_groups_doc_revision_request,
        });
    }

    onCancelUpdateButton() {
        this.selectedDocumentUuid = null;
        this.selectedDocumentName = null;
    }

    onRemoveGridButton({item}) {
        this.removeDocumentFromEvidenceGroup({
            vdo_uuid: item.id,
            evg_id: this.details.ard_id,
            slo_uuid: this.siteLocationUuid,
            requirement_id: this.requirement?.id,
        }).then(() => {
            this.$ngRedux.dispatch({
                type: GRID_RELOAD,
                id: IDS.rcoRequirementsAssessment,
                path: IDS.rcoEvidenceGroupDocumentsGrid
            });
            this.$ngRedux.dispatch({
                type: GRID_RELOAD,
                id: IDS.rcoRequirementsAssessment,
                path: IDS.rcoEvidenceGroupHistoryGrid
            });
            this.reloadDetailsAndStatuses();
        });
    }

    reloadDetailsAndStatuses() {
        const requirementId = this.requirement?.id;
        const siteLocationUuid = this.siteLocationUuid;
        const year = this.fiscalYear;
        this.fetchRequirementAuditorStatuses(requirementId, siteLocationUuid, year, this.userUuid, this.details.ard_id)
        this.fetchEvidenceGroupsProgressGrid({requirementId, siteLocationUuid, year}).then(() => {
            this.$ngRedux.dispatch({
                type: TYPES.SELECT_EVIDENCE_DETAILS,
                ardId: this.details.ard_id,
                firstDocType: this.firstDocType,
            });
        });
        // this.reloadTilesStatuses();
    }

    // reloadTilesStatuses () {
    //     const ctrl = this;
    //     this.fetchAssessmentRequirementsTreeProgress(this.schemeCode, this.siteLocationUuid, year).then((data) => {
    //         ctrl.selectRequirementById(requirementId);
    //     });
    // }

    async onReviewerAutocompleteKeywordQuery (keyword) {
        // if(this.isQManagersSwitchOn) {
        //     return keyword ?
        //         this.reviewers.filter(this.getFilter(keyword))
        //         : this.reviewers
        // }
        // else
            return await this.fetchReviewerCandidates(keyword, this.siteLocationUuid);
    }

    $onDestroy() {
        if(this.unsubscribe)
            this.unsubscribe();

        if(this.onEnterUnsubscribe)
            this.onEnterUnsubscribe();
    }
}

EvidenceGroupDetailsController.$inject = [
    '$ngRedux',
    '$state',
    '$stateParams',
    '$filter',
    '$timeout',
    '$transitions',
    'Notifier',
    'DocumentManager',
    'EmployeeService',
    'AuthService',
    'FileActions',
    '$scope']

export const evidenceGroupDetails = {
    controller: EvidenceGroupDetailsController,
    template: require('./evidence-group-details.html')
}
